<div class="row mb-3" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/hourglass/tools'">
      <i class="fas fa-fw fa-lock me-2"></i>Admin Tools<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <i class="fas fa-fw fa-object-group me-2"></i>Tax Lots Procedure
  </div>
</div>
<div class="taxlots-container">
  <h3 class="taxlots-header">Run Tax Lots Procedure</h3>

  <form (ngSubmit)="runTaxLots()" #taxForm="ngForm" class="mb-3">
    <div class="mb-3">
      <label for="entity" class="form-label">Entity</label>
      <input
        type="text"
        id="entity"
        name="entity"
        [(ngModel)]="entity"
        required
        class="form-control"
        placeholder="Enter entity"
      />
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="!entity || loading">
      {{ loading ? 'Running...' : 'Run Procedure' }}
    </button>
  </form>

  <div *ngIf="result" class="alert alert-success mt-3">
    <strong>Result:</strong>
    <pre>{{ result | json }}</pre>
  </div>

  <div *ngIf="error" class="alert alert-danger mt-3">
    <strong>Error:</strong> {{ error }}
  </div>
</div>
